/**
 * The timer callback events.
 */
enum TimerEvent
{
    /**
     * Event emitted at every interval
     * with the current time in ms.
     */
    Tick = 'tick',

    /**
     * Event emitted when the timer
     * reaches the duration set.
     */
    Done = 'done',

    /**
     * Event emitted when the timer status
     * changed.
     */
    StatusChanged = 'statusChanged,'
}

export default TimerEvent;
